import Filter from './filter';

export default Filter((FILTER_TYPES) => ({
  id: 'FAMILYHOTEL',
  analyticsName: 'Family recommended',
  queryKey: 'f_family',
  type: FILTER_TYPES.BOOLEAN,
  bucketify: (hotel) => {
    const isFamilyHotel = hotel?.isFamilyHotel;

    if (isFamilyHotel) {
      return {
        bucketId: FILTER_TYPES.BINARY_BUCKET.TRUE,
        bucketName: 'allFamilyHotel',
      };
    }

    return {
      bucketId: FILTER_TYPES.BINARY_BUCKET.FALSE,
      bucketName: 'allFamilyHotel',
    };
  },
  toQuery: ({ value }) => {
    return value ? 1 : undefined;
  },
  fromQuery: (rawQueryValue) => {
    return {
      [FILTER_TYPES.BINARY_BUCKET.TRUE]: !!rawQueryValue,
    };
  },
}));
